export default __webpack_public_path__ + "static/media/kiji_simple.7f823abf.png";